import { TabNavigation } from 'src/common/TabNavigation';

const tabs = [
  { name: 'MTM', href: '/admin/mtm' },
  { name: 'Momentm', href: '/admin/momentm' },
  { name: 'Kinetik', href: '/admin/kinetik' },
  { name: 'Alivi', href: '/admin/alivi' },
  { name: 'Internal', href: '/admin/internal' },
  { name: 'Clearview', href: '/admin/clearview' },
];

export function AdminNav() {
  return <TabNavigation tabs={tabs} />;
}
